import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ListEnvironmentConstants from './ListEnvironmentConstants';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CreateEnvironmentConstant from './CreateEnvironmentConstant';

const EnvironmentConstants = ({
  projectId,
  version,
  environments,
  appSetting,
  actions,
  deleteFlag,
}) => {
  const [activeEnv, setActiveEnv] = useState('PREVIEW');
  const switchEnvTab = (tab) => {
    if (activeEnv !== tab) setActiveEnv(tab);
  };

  const showProjectConstants = () => {
    if (environments && environments.length > 0) {
      return (
        <>
          <Nav pills className="nav-pills-primary drapcode-nav-pills">
            {environments.map((environment) => (
              <NavItem key={environment.envType}>
                <NavLink
                  className={classnames({ active: activeEnv === environment.envType })}
                  onClick={() => {
                    switchEnvTab(environment.envType);
                  }}
                >
                  {environment.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeEnv}>
            {environments.map((environment) => (
              <TabPane tabId={environment.envType} key={environment.envType}>
                {environment.constants ? (
                  <ListEnvironmentConstants
                    envId={environment.uuid}
                    envType={environment.envType}
                    projectId={projectId}
                    constants={environment.constants}
                    appSetting={appSetting}
                    actions={actions}
                    version={version}
                    deleteFlag={deleteFlag}
                  />
                ) : (
                  'No Constants'
                )}
              </TabPane>
            ))}
          </TabContent>
        </>
      );
    }
  };

  return (
    <>
      <ParentCardNoCol bgColor="drapcode-violet" icon="form" title="Environment's Variables">
        <CreateEnvironmentConstant
          projectId={projectId}
          actions={actions}
          appSetting={appSetting}
          version={version}
          environments={environments}
        />
        {showProjectConstants()}
      </ParentCardNoCol>
    </>
  );
};

export default EnvironmentConstants;
